import { Box } from "@mui/material"
import {
  Gear,
  IconProps,
  Microphone,
  MicrophoneSlash,
  VideoCamera,
} from "@phosphor-icons/react"
import { VideoCameraSlash } from "@phosphor-icons/react/dist/ssr"
import React from "react"
import { useAppContext } from "../../app/Context"
import { Colors } from "../../constants/colors"

interface MediaControlsBarProps {
  isMicEnabled: boolean
  isCameraEnabled: boolean
  toggleMicrophone: () => void
  toggleCamera: () => void
  onSettingsClick: () => void
  position?: "fixed" | "absolute"
  bottom?: string
  containerStyle?: React.CSSProperties
}

interface ContainerProps {
  display: string
  alignItems: string
  justifyContent: string
  sx: any
  width: number
  height: number
  borderRadius: string
}

const containerProps: ContainerProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  sx: {
    cursor: "pointer",
    backgroundColor: "var(--primitives-desktop-primary-transparent-black-60)",
    "&:hover": {
      backgroundColor: "var(--primitives-desktop-primary-transparent-gray-40)",
    },
  },
  width: 60,
  height: 60,
  borderRadius: "50%",
}

const iconProps: IconProps = {
  size: 32,
}

export const MediaControlsBar: React.FC<MediaControlsBarProps> = ({
  isMicEnabled,
  isCameraEnabled,
  toggleMicrophone,
  toggleCamera,
  onSettingsClick,
  position = "absolute",
  bottom = "5%",
  containerStyle,
}) => {
  const context = useAppContext()
  const stream = context.stream

  if (!stream) return null

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      gap={2}
      sx={{
        position: position,
        bottom: bottom,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000,
        ...containerStyle,
      }}
    >
      <Box
        {...containerProps}
        onClick={toggleCamera}
        sx={{
          ...containerProps.sx,
          backgroundColor: !isCameraEnabled
            ? "black"
            : "var(--primitives-desktop-primary-transparent-black-60)",
        }}
      >
        {isCameraEnabled ? (
          <VideoCamera {...iconProps} color={Colors.White} />
        ) : (
          <VideoCameraSlash {...iconProps} color={Colors.Yellow} />
        )}
      </Box>
      <Box
        {...containerProps}
        onClick={toggleMicrophone}
        sx={{
          ...containerProps.sx,
          backgroundColor: !isMicEnabled
            ? "black"
            : "var(--primitives-desktop-primary-transparent-black-60)",
        }}
      >
        {isMicEnabled ? (
          <Microphone {...iconProps} color={Colors.White} />
        ) : (
          <MicrophoneSlash {...iconProps} color={Colors.Yellow} />
        )}
      </Box>
      <Box {...containerProps} onClick={onSettingsClick}>
        <Gear {...iconProps} color={Colors.White} />
      </Box>
    </Box>
  )
}
